export const getIsGroupEl = (self, el) => {
  const grouping = self._getGroupingThrowable();
  return grouping.getIsGroup(el);
};
